import { render, staticRenderFns } from "./runRecordPage.vue?vue&type=template&id=3b4ac5f6&scoped=true"
import script from "./runRecordPage.vue?vue&type=script&lang=js"
export * from "./runRecordPage.vue?vue&type=script&lang=js"
import style0 from "./runRecordPage.vue?vue&type=style&index=0&id=3b4ac5f6&prod&lang=scss&scoped=true"
import style1 from "./runRecordPage.vue?vue&type=style&index=1&id=3b4ac5f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4ac5f6",
  null
  
)

export default component.exports